import { Checkbox, Input, Modal, Select } from "antd";
import React, { useState, useEffect, useContext } from "react";
import { error, success } from "../../contants/snackbars";
import { addFaq, editFaq } from "../../stores/api_calls/faqs";

const { TextArea } = Input;

const FaqForm = ({ visible, onCancel, addFaqSuccess, isEditing, data, totalRecord }) => {
  const [requestLoading, setRequestLoading] = useState(false);
  const [form, setForm] = useState({
    question: "",
    answer: "",
    type: [],
    orderNumber: 1,
  });

  useEffect(() => {
    if (isEditing) {
      setForm({
        ...form,
        id: data.id,
        question: data.question,
        answer: data.answer,
        type: data.type,
        orderNumber: data.order_number,
      });
    } else {
      setForm({
        question: "",
        answer: "",
        type: [],
        orderNumber: null,
      });
    }
  }, [isEditing]);

  const handleFieldChange = (name, e) => {
    setForm({ ...form, [name]: e.target.value });
  };

  const handleMultipleDropdownChange = (name, value) => {
    setForm({
      ...form,
      [name]: value,
    });
  };

  const onSubmit = () => {
    const createFaq = addFaq(form);
    createFaq
      .then((res) => {
        if (res.data.success) {
          success("FAQ Created Successfully");
          addFaqSuccess();
          setRequestLoading(false);
        }
      })
      .catch((e) => {
        error("Failed to Add FAQ");
        setRequestLoading(false);
      });
  };

  const onUpdate = () => {
    const updateFaq = editFaq(form);
    updateFaq
      .then((res) => {
        if (res.data.success) {
          success("FAQ Updated Successfully");
          addFaqSuccess();
          setRequestLoading(false);
        }
      })
      .catch((e) => {
        error(`Opps! Update failed. Please try again later`);
      });
  };

  const orderNumberOptions = Array.from(
    { length: totalRecord || 0 },
    (_, i) => ({
      value: i + 1,
      label: i + 1,
    })
  );

  return (
    <div>
      <Modal
        className="formModal"
        title={`${isEditing ? "Edit" : "Add"} FAQ`}
        visible={visible}
        onOk={isEditing ? onUpdate : onSubmit}
        onCancel={onCancel}
        okText={`${isEditing ? "Save" : "Submit"}`}
        width={'800px'}
      >
        <div className="field-container">
          <p className="field-label">Question <span style={{color:'red'}}>*</span>: </p>
          <Input
            value={form.question}
            placeholder="Question"
            onChange={(text) => handleFieldChange("question", text)}
          />
        </div>

        <div className="field-container">
          <p className="field-label">Answer <span style={{color:'red'}}>*</span>: </p>
          <TextArea
            rows={4}
            value={form.answer}
            placeholder="Type Answer"
            onChange={(text) => handleFieldChange("answer", text)}
          />
        </div>

        <div className="field-container">
          <p className="field-label">Type <span style={{color:'red'}}>*</span>: </p>
          <Select
            mode="multiple"
            placeholder="Select Type"
            value={form.type}
            onChange={(value) =>
              handleMultipleDropdownChange("type", value)
            }
            style={{
              width: "100%",
            }}
            options={[
              {value: "sellcar", label: "Sell Car"},
              {value: "sellcarbid", label: "Sell Car Bid"},
            ]}
          />
        </div>

        {/* <div className="field-container">
          <p className="field-label">
            Order Number <span style={{ color: "red" }}>*</span>:
          </p>

          <Select
            placeholder="Select Order Number"
            value={form.orderNumber}
            onChange={(value) =>
              setForm({ ...form, orderNumber: value })
            }
            style={{ width: "100%" }}
            options={orderNumberOptions}
          />
        </div> */}
      </Modal>
    </div>
  );
};

export default FaqForm;
